<template>
  <div class="page-shell">
    <div class="ambient ambient-left"></div>
    <div class="ambient ambient-right"></div>

    <main class="login-layout">
      <section class="brand-panel"></section>

      <section class="card-panel">
        <div class="logo-wrap">
          <img
            class="logo login-logo"
            src="/image/white-logo.png"
            alt="兔灵智绘"
          >
        </div>

        <div class="login-card">
          <div class="card-header">
            <p class="eyebrow">欢迎回来</p>
            <h2>账号登录</h2>
            <p class="card-copy">请输入邮箱或手机号以及密码，登录成功后会自动进入首页。</p>
          </div>

          <form class="login-form" @submit.prevent="submitForm">
            <label class="field">
              <span>邮箱或手机号</span>
              <input
                v-model.trim="form.account"
                type="text"
                autocomplete="username"
                placeholder="请输入邮箱或手机号"
              >
            </label>

            <label class="field">
              <span>密码</span>
              <input
                v-model.trim="form.password"
                type="password"
                autocomplete="current-password"
                placeholder="请输入密码"
              >
            </label>

            <button class="submit-button" type="submit" :disabled="submitting">
              {{ submitting ? '登录中...' : '登录并进入首页' }}
            </button>
          </form>

          <div class="switch-auth">
            <span>还没有账号？</span>
            <router-link :to="{ name: 'register' }">去注册</router-link>
          </div>

          <p v-if="message.text" class="status-text" :class="message.type">
            {{ message.text }}
          </p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { login } from "../api/auth";
import { saveAuthState } from "../utils/auth";

var MAINLAND_PHONE_PATTERN = /^1\d{10}$/;

export default {
  name: "LoginView",
  data: function data() {
    return {
      submitting: false,
      form: {
        account: "",
        password: ""
      },
      message: {
        type: "",
        text: ""
      }
    };
  },
  methods: {
    async submitForm() {
      var account = this.form.account;
      var password = this.form.password;

      if (!account) {
        this.setMessage("error", "请输入邮箱或手机号。");
        return;
      }

      if (!password) {
        this.setMessage("error", "请输入密码。");
        return;
      }

      this.submitting = true;
      this.setMessage("", "");

      try {
        var payload = await login(this.buildLoginPayload(account, password));

        saveAuthState({
          accessToken: payload.access_token,
          tokenType: payload.token_type,
          expiresIn: payload.expires_in,
          user: payload.user
        });

        this.$router.push({ name: "home" });
      } catch (error) {
        this.setMessage("error", this.resolveErrorMessage(error));
      } finally {
        this.submitting = false;
      }
    },
    buildLoginPayload: function buildLoginPayload(account, password) {
      var payload = {
        password: password
      };

      if (this.isPhoneAccount(account)) {
        payload.phone = account;
      } else {
        payload.email = account;
      }

      return payload;
    },
    isPhoneAccount: function isPhoneAccount(account) {
      return MAINLAND_PHONE_PATTERN.test(account);
    },
    resolveErrorMessage: function resolveErrorMessage(error) {
      if (error && error.validationErrors) {
        var firstKey = Object.keys(error.validationErrors)[0];
        if (firstKey) {
          return error.validationErrors[firstKey][0];
        }
      }

      return (error && error.message) || "请求失败，请稍后重试。";
    },
    setMessage: function setMessage(type, text) {
      this.message = {
        type: type,
        text: text
      };
    }
  }
};
</script>

